// Definir constants per literals repetits
const COMMON_SIZES = {
    MOBILE_TABLET_DESKTOP: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(100vw - 80px), 1224px',
};


export const sizesPredef = {
    web_destacat: {
        default: COMMON_SIZES.MOBILE_TABLET_DESKTOP,
        2: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 2), 188px',
        3: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 3), 300px',
        4: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 4), 400px',
        6: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 6), 600px',
        8: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 8), 800px',
        9: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 9), 900px',
        12: COMMON_SIZES.MOBILE_TABLET_DESKTOP
    },
    web_playerpodcast: {
        default: COMMON_SIZES.MOBILE_TABLET_DESKTOP,
        2: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 2), 188px',
        3: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 3), 280px',
        4: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 4), 380px',
        6: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 6), 600px',
        8: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 8), 800px',
        9: '(max-width: 719px) calc(100vw - 32px), (max-width: 1023px) calc(100vw - 80px), (max-width: 1303px) calc(((100vw - 80px) / 12) * 9), 900px',
        12: COMMON_SIZES.MOBILE_TABLET_DESKTOP
    },
    web_slider: {
        default: COMMON_SIZES.MOBILE_TABLET_DESKTOP,
        2: '(max-width: 719px) calc((100vw - 32px) / 2), (max-width: 1023px) calc((100vw - 80px) / 2), (max-width: 1920px) calc(1224px / 2), 803px',
        3: '(max-width: 719px) calc((100vw - 32px) / 3), (max-width: 1023px) calc((100vw - 80px) / 3), (max-width: 1920px) calc(1224px / 3), 535px',
        4: '(max-width: 719px) calc((100vw - 32px) / 4), (max-width: 1023px) calc((100vw - 80px) / 4), (max-width: 1920px) calc(1224px / 4), 401px',
        5: '(max-width: 719px) calc((100vw - 32px) / 5), (max-width: 1023px) calc((100vw - 80px) / 5), (max-width: 1920px) calc(1224px / 5), 321px',
        6: '(max-width: 719px) calc((100vw - 32px) / 6), (max-width: 1023px) calc((100vw - 80px) / 6), (max-width: 1920px) calc(1224px / 6), 267px',
        7: '(max-width: 719px) calc((100vw - 32px) / 7), (max-width: 1023px) calc((100vw - 80px) / 7), (max-width: 1920px) calc(1224px / 7), 229px',
        8: '(max-width: 719px) calc((100vw - 32px) / 8), (max-width: 1023px) calc((100vw - 80px) / 8), (max-width: 1920px) calc(1224px / 8), 200px'
    },
    web_autor: {
        default:
            '(max-width: 569px) calc((100vw - 32px) / 2), (max-width: 768px) ' +
            'calc((100vw - 80px) / 5), (max-width: 1303px) calc((100vw - 136px) / 8), (max-width: 1600px) calc(1224px / 8),' +
            '(max-width: 2256px) calc(1600px / 8), 256px'
    },
    web_autor_capcalera: {
        default: '(max-width: 1303px) 256px, 384px'
    },
    web_capcalera_seccio: {
        default: '(max-width: 720px) 180px, (max-width: 1024px) calc(100vw / 1.5), (max-width: 2256px) calc(100vw / 2), 2256px'
    },
    web_destacat_horitzontal: {
        default:
            '(max-width: 430px) 256px, (max-width: 719px) calc((100vw - 32px / 2)), (max-width: 1023px) calc((100vw - 80px / 2)), (max-width: 1303px) calc((100vw - 80px / 2)), 612px'
    },
    web_mosaic: {
        default:
            '(max-width: 569px) calc(100vw - 32px), (max-width: 767px) calc((100vw - 48px) / 2), (max-width: 926px) calc((100vw - 84px) / 2),' +
            '(max - width: 1210px) calc((100vw - 100px) / 3), (max - width: 1439px) calc((100vw - 116px) / 4),' +
            '(max - width: 1920px) calc((100vw - 160px) / 4), 468px'
    },
    web_metadades_priority: { default: '(max-width: 2256px) 100vw, 2256px' },
    web_xxss: { default: '(max-width: 2256px) 100vw, 2256px' },
    web_noti: {
        default:
            '(max-width: 719px) calc(100vw - 32px), (max-width: 744px) calc(100vw - 80px),' +
            ' (max-width: 1194px) calc(100vw - 162px), (max-width: 1920px) 1018px, 1328px'
    }
};

export const cropPredef = {
    web_autor: '124x140',
    web_autor_capcalera: '124x140',
    web_capcalera_seccio: '1903',
    web_destacat: '1903',
    web_slider: '1903',
    web_destacat_horitzontal: '670x378',
    web_mosaic: '621x350',
    web_metadades_priority: '1903',
    web_metadades_priority_amp: '640x433',
    web_xxss: '1920x1080',
    web_player_poster_background: '1903',
    web_reels: '287x509',
    web_informatius_destacats: '288x422'
};
export const tipusPredef = {
    web_autor: [
        { rel_name: 'IMATGE', mida: 'MASTER' },
        { rel_name: 'imatge', mida: 'MASTER' }
    ],
    web_autor_capcalera: [
        { rel_name: 'IMATGE', mida: 'MASTER' },
        { rel_name: 'imatge', mida: 'MASTER' }
    ],
    web_capcalera_seccio: [{ mida: 'MASTER' }],
    web_destacat: [{ mida: 'MASTER' }],
    web_slider: [{ mida: 'MASTER' }],
    web_destacat_horitzontal: [{ mida: 'MASTER' }],
    web_mosaic: [
        { rel_name: 'IMATGE_CUSTOM', mida: 'DESTACAT_IMATGE' },
        { rel_name: 'IMATGE_169', mida: 'MASTER' },
        { mida: 'MASTER' }
    ],
    web_metadades_priority: [{ mida: 'MASTER' }],
    web_xxss: [{ mida: 'MASTER' }, { mida: 'XS' }],
    web_logo: [{ rel_name: 'IMG_LOGO', mida: 'MASTER' }],
    web_playerpodcast: [{ rel_name: 'IMATGE_169', tipologia: 'WCR_AUDIO', mida: 'MASTER' }],
    web_reels: [
        { rel_name: 'IMG_POSTER', mida: 'MASTER' },
        { rel_name: 'KEYVIDEO', mida: 'MASTER' }
    ],
    web_informatius_destacats: [{ rel_name: 'IMAGE', mida: 'MASTER' }],
    web_player_poster_background: [
        { rel_name: 'imatge_169', mida: 'MASTER' },
        { rel_name: 'IMATGE_169', mida: 'MASTER' },
        { rel_name: 'keyvideo', mida: 'MASTER' },
        { rel_name: 'imatge', mida: 'MASTER' },
        { mida: 'MASTER' },
        { realname: 'IMATGE' }
    ]
};
